import styled from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { breakpoints } from '@/config/layout'

const RequiredVersionContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: max(20vh, 200px);
`

const RequiredVersionContent = styled(FlexColumn)`
  @media ${breakpoints.fromS} {
    padding: ${({ theme }) => theme.UI.SpacingPx.Space16} 50px;
  }

  @media ${breakpoints.fromL} {
    padding: ${({ theme }) => theme.UI.SpacingPx.Space16} 100px;
  }
`

export { RequiredVersionContent, RequiredVersionContentContainer }
